import { connect } from 'react-redux';

import ConfirmationModalContent from '../components/forms/ConfirmationModalContent';

export const mapStateToProps = state => ({
  showNewConfirmationModal:
    state.splitTreatments &&
    state.splitTreatments['av-new-confirmation-modal'] === 'on',
});

export default connect(
  mapStateToProps,
  {}
)(ConfirmationModalContent);
